import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { globals } from '../utils/globals';
import { HttpService } from '../services/http-service';
import { UrlService } from '../services/url-service';
import { TransferStateService } from 'src/services/transfer-state.service';
import { TokenStorageService } from 'src/services/token-storage.service';
import { User } from 'src/app/models/user.model';

@Injectable()
export class UserRestService extends HttpService<User> {
  
  constructor(
    override _translateService: TranslateService,
    override _globals: globals,
    override _http: HttpClient,
    override _transferStateService: TransferStateService,
    private _tokenStorageService: TokenStorageService,
    private urlService: UrlService,
  ) {
    super(_http, _translateService, _globals, _transferStateService);
  }

  getUserById(id : any): Observable<User> {
    let url = this.urlService.getUserByIdURL() + id;

    let data: any = {};
    let header: any = {};
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject;
    }
    return this._get(url, data, header).pipe(
      map((result: User) => {
        //console.log(result);
        return result;
      })
    );
  }
}
